import { containerHighlight, containerHighlightDark, ellipsisMultiline, threadHistoryToggleButton } from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useSortButtonStyle = makeStyles({
	button: {
		minWidth: "unset",
	},
	iconPlaceholder: {
		width: "20px",
		display: "inline-block",
	},
});

export const useStyle = makeStyles({
	rootContainer: {
		backgroundColor: "white",
		overflow: "hidden",
		padding: "12px 16px",
		borderRadius: tokens.borderRadiusMedium,
	},
	rootContainerHighlighted: {
		backgroundColor: "white",
		overflow: "hidden",
		padding: "12px 16px",
		borderRadius: tokens.borderRadiusMedium,
		...containerHighlight()
	},
	rootContainerHighlightedDark: {
		backgroundColor: "white",
		overflow: "hidden",
		padding: "12px 16px",
		borderRadius: tokens.borderRadiusMedium,
		...containerHighlightDark()
	},
	header: {
		cursor: "pointer",
	},
	hidden: {
		opacity: 0,
	},
	bodyContainer: {
		paddingLeft: "44px",
	},
	attachHeaderIcon: {
		margin: "6px",
	},
	hiddenOverflow: { overflow: "hidden" },
	previewText: {
		whiteSpace: "pre-line",
		...ellipsisMultiline(2),
	},
	threadHistoryToggleButton: {
		...threadHistoryToggleButton(),
	},
	threadHistoryToggleWrapper: {
		marginTop: `calc(-1 * ${tokens.spacingVerticalM})`,
	},
	dangerouslyContainer: {
		lineBreak: "anywhere",
		lineHeight: "normal",
		"& img": {
			maxWidth: "100%",
			height: "auto",
		},
	},
});
